import React, { useEffect, useMemo } from 'react';
import TopLeaderCard from './TopLeaderCard/TopLeaderCard';
import LeaderGrid from './LeaderGrid/LeaderGrid';
import { isBrowser } from '../../shared/isBrowser';
import './LeaderPage.scss';

interface ILeaderPageProps {
    edic: boolean;
    /** The max width of the grid */
    maxGridWidth: number;
    /** Used to set the max width of the grid so other components on the page can be constrained to this size */
    setMaxGridWidth: React.Dispatch<React.SetStateAction<number>>;
}

const LeaderPage = ({
    edic,
    maxGridWidth,
    setMaxGridWidth,
}: ILeaderPageProps): React.ReactNode => {
    const hrWidth = useMemo(() => {
        if (maxGridWidth < 520) {
            return 330 * 0.75;
        }
        return maxGridWidth * 0.8;
    }, [maxGridWidth]);

    useEffect(() => {
        if (isBrowser) {
            window.scrollTo({ top: 0 });
        }
    }, []);

    return (
        <section className="kite-container leadership__grid">
            <div className="top-leaders">
                <TopLeaderCard maxGridWidth={maxGridWidth} />
            </div>
            <hr
                className="leadership__grid_hr"
                style={{ width: `${hrWidth}px` }}
            />
            <LeaderGrid
                edic={edic}
                maxGridWidth={maxGridWidth}
                setMaxGridWidth={setMaxGridWidth}
            />
        </section>
    );
};

export default LeaderPage;
